import { cloneElement, useId, type ReactElement } from "react";

type Props = {
  label: string;
  required?: boolean;
  error?: string;
  hint?: string;
  children: ReactElement<Record<string, unknown>>;
  className?: string;
};

export function Field({ label, required, error, hint, children, className = "col-md-6" }: Props) {
  const id = useId();
  const describedBy = [error && `${id}-err`, hint && `${id}-hint`].filter(Boolean).join(" ") || undefined;
  const native = typeof children.type === "string";
  const own = children.props.className as string | undefined;
  return (
    <div className={`${className} mb-3`}>
      <label htmlFor={id} className="form-label">
        {label}
        {required && (
          <span className="text-danger" aria-hidden="true">
            {" "}
            *
          </span>
        )}
      </label>
      {cloneElement(children, {
        id,
        "aria-invalid": error ? "true" : undefined,
        "aria-required": required || undefined,
        "aria-describedby": describedBy,
        // Inputs próprios (MoneyInput, DocInput...) mantêm a classe padrão e marcam is-invalid pelo aria-invalid.
        ...(native ? { className: `${own ?? "form-control"}${error ? " is-invalid" : ""}` } : {}),
      })}
      {hint && (
        <div id={`${id}-hint`} className="form-text">
          {hint}
        </div>
      )}
      {error && (
        <div id={`${id}-err`} className="invalid-feedback d-block">
          {error}
        </div>
      )}
    </div>
  );
}
